import IconBullets from './IconBullets';

export default IconBullets;
